const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    accountNumber: 'Account Number:',
    accountNumberPlaceholder: 'Account Number',
    routingNumber: 'Rounting Number:',
    routingPlaceholder: '9 digit Routing (ABA)',
    amount: 'Amount:',
    amountPlaceholder: 'Amount',
    currency: 'Currency',
    payoutLimits: 'PayoutLimits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    accountType: 'Account Type:',
    personalChecking: 'Personal Checking',
    personalSavings: 'Personal Savings',
    bankInformation: 'Bank information',
    bankName: 'Bank name:',
    bankNamePlaceholder: 'bank name',
    bankNumber: 'Bank number:',
    bankNumberPlaceholder: 'bank number',
    bankState: 'Bank State:',
    bankCity: 'Bank City:',
    bankCityPlaceholder: 'bank city',
    personalInformation: 'Personal information',
    firstName: 'First Name:',
    firstNamePlaceholder: 'first name',
    lastName: 'Last name:',
    lastNamePlaceholder: 'last name',
    country: 'Country:',
    countryPlaceholder: 'Country',
    state: 'State:',
    stateProvPlaceholder: 'State / Prov',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    accountNumber: 'Número de Cuenta:',
    accountNumberPlaceholder: 'Número de Cuenta',
    routingNumber: 'Número de Ruta:',
    routingPlaceholder: 'Ruta de 9 dígitos (ABA)',
    amount: 'Monto:',
    amountPlaceholder: 'Monto',
    currency: 'Moneda',
    payoutLimits: 'Límites de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    accountType: 'Tipo de Cuenta:',
    personalChecking: 'Cuenta Corriente Personal',
    personalSavings: 'Cuenta de Ahorros Personal',
    bankInformation: 'Información Bancaria',
    bankName: 'Nombre del banco:',
    bankNamePlaceholder: 'nombre del banco',
    bankNumber: 'Número del banco:',
    bankNumberPlaceholder: 'número del banco',
    bankState: 'Estado del Banco:',
    bankCity: 'Ciudad del Banco:',
    bankCityPlaceholder: 'ciudad del banco',
    personalInformation: 'Información Personal',
    firstName: 'Nombre:',
    firstNamePlaceholder: 'nombre',
    lastName: 'Apellido:',
    lastNamePlaceholder: 'apellido',
    country: 'País:',
    countryPlaceholder: 'País',
    state: 'Estado:',
    stateProvPlaceholder: 'Estado / Provincia',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    accountNumber: 'Número de Conta:',
    accountNumberPlaceholder: 'Número de Conta',
    routingNumber: 'Número de Roteamento:',
    routingPlaceholder: 'Roteamento de 9 dígitos (ABA)',
    amount: 'Valor:',
    amountPlaceholder: 'Valor',
    currency: 'Moeda',
    payoutLimits: 'Limites de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    accountType: 'Tipo de Conta:',
    personalChecking: 'Conta Corrente Pessoal',
    personalSavings: 'Conta Poupança Pessoal',
    bankInformation: 'Informações Bancárias',
    bankName: 'Nome do banco:',
    bankNamePlaceholder: 'nome do banco',
    bankNumber: 'Número do banco:',
    bankNumberPlaceholder: 'número do banco',
    bankState: 'Estado do Banco:',
    bankCity: 'Cidade do Banco:',
    bankCityPlaceholder: 'cidade do banco',
    personalInformation: 'Informações Pessoais',
    firstName: 'Nome:',
    firstNamePlaceholder: 'nome',
    lastName: 'Sobrenome:',
    lastNamePlaceholder: 'sobrenome',
    country: 'País:',
    countryPlaceholder: 'País',
    state: 'Estado:',
    stateProvPlaceholder: 'Estado / Província',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
